export default __webpack_public_path__ + "locales/lo-LA/People.json?hash=e4955fd24c50aacdc9b68c3393640682";